import PropTypes from "prop-types"
import React, { useEffect, useRef, useCallback } from "react"

import FeatherIcon from "feather-icons-react";
import giftBox from "../../assets/images/giftbox.png"
import SimpleBar from "simplebar-react"
import MetisMenu from "metismenujs"
import { Link, useLocation } from "react-router-dom"
import withRouter from "../Common/withRouter"
import { withTranslation } from "react-i18next"
import { getStoredAdminRole, ADMIN_ROLE, isMarketerReadOnly } from "../../helpers/adminRole"

const SidebarContent = props => {
  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show");
        const parent3 = parent2.parentElement;
        if (parent3) {
          parent3.classList.add("mm-active");
          parent3.childNodes[0].classList.add("mm-active");
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("mm-show");
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show");
              parent5.childNodes[0].classList.add("mm-active");
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active");
            parent3.childNodes[0].classList.remove("mm-active");
            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.remove("mm-show");
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show");
                parent5.childNodes[0].classList.remove("mm-active");
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    if (!ul) return;
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("AI")} </li>
            <li>
              <Link to="/ai/dashboard" className="">
                <FeatherIcon icon="home" />{" "}
                <span>{props.t("AI dashboard")}</span>
              </Link>
            </li>
            <li>
              <Link to="/ai/parents" className="">
                <FeatherIcon icon="user" />{" "}
                <span>{props.t("Manage parents (AI)")}</span>
              </Link>
            </li>
            <li>
              <Link to="/ai/subscription-plans" className="">
                <FeatherIcon icon="layers" />{" "}
                <span>{props.t("Subscription plans")}</span>
              </Link>
            </li>
            <li>
              <Link to="/ai/referral-codes" className="">
                <FeatherIcon icon="tag" />{" "}
                <span>{props.t("Referral Codes")}</span>
              </Link>
            </li>
            <li>
              <Link to="/ai/subscribers" className="">
                <FeatherIcon icon="credit-card" />{" "}
                <span>{props.t("Subscribed parents")}</span>
              </Link>
            </li>
            <li>
              <Link to="/ai/clicked-subscribe" className="">
                <FeatherIcon icon="mouse-pointer" />{" "}
                <span>{props.t("Clicked subscribe")}</span>
              </Link>
            </li>
            <li>
              <Link to="/ai/metrics" className="">
                <FeatherIcon icon="bar-chart-2" />{" "}
                <span>{props.t("Manage Metrics")}</span>
              </Link>
            </li>
            <li>
              <Link to="/ai/curriculum" className="">
                <FeatherIcon icon="book-open" />{" "}
                <span>{props.t("Manage Curriculum")}</span>
              </Link>
            </li>
            <li>
              <Link to="/ai/learning-paths" className="">
                <FeatherIcon icon="map" />{" "}
                <span>{props.t("Learning Paths")}</span>
              </Link>
            </li>
            {/* Not in the marketer allowlist (helpers/adminRole.js), so hidden for marketers. */}
            {!isMarketerReadOnly() && (
              <>
              <li>
                <Link to="/ai/tests" className="">
                  <FeatherIcon icon="check-square" />{" "}
                  <span>{props.t("Manage Tests")}</span>
                </Link>
              </li>
              <li>
                <Link to="/ai/test-grades" className="">
                  <FeatherIcon icon="award" />{" "}
                  <span>{props.t("Test Grading")}</span>
                </Link>
              </li>
              <li>
                <Link to="/ai/test-attempts" className="">
                  <FeatherIcon icon="clipboard" />{" "}
                  <span>{props.t("Test Attempts")}</span>
                </Link>
              </li>
              </>
            )}
            <li>
              <Link to="/ai/learning-path-categories" className="">
                <FeatherIcon icon="layers" />{" "}
                <span>{props.t("Path Categories")}</span>
              </Link>
            </li>
            <li>
              <Link to="/ai/feedback" className="">
                <FeatherIcon icon="message-square" />{" "}
                <span>{props.t("Manage Feedback")}</span>
              </Link>
            </li>
            {isMarketerReadOnly() && (
              <>
                <li className="menu-title">{props.t("Platform")}</li>
                <li>
                  <Link to="/manage-parent" className="">
                    <FeatherIcon icon="user" />{" "}
                    <span>{props.t("Manage Parent")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/manage-child" className="">
                    <FeatherIcon icon="users" />{" "}
                    <span>{props.t("Manage Child")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/manage-program" className="">
                    <FeatherIcon icon="feather" />{" "}
                    <span>{props.t("Manage Program")}</span>
                  </Link>
                </li>
                <li className="menu-title">{props.t("Partners")}</li>
                <li>
                  <Link to="/manage-partner" className="">
                    <FeatherIcon icon="briefcase" />{" "}
                    <span>{props.t("Manage Partners")}</span>
                  </Link>
                </li>
              </>
            )}
          </ul>
          <div className="card sidebar-alert border-0 text-center mx-4 mb-0 mt-5">
            <div className="card-body">
              <div className="mt-4">
                <h5 className="alertcard-title font-size-16">Administrator</h5>
                <p className="font-size-13">Return to the main admin area.</p>
                <Link
                  to="/dashboard"
                  className="btn btn-primary mt-2"
                >
                  Main dashboard
                </Link>
              </div>
            </div>
          </div>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
